import { gql } from "@apollo/client";

export interface BlogTagData {
  id: string;
  name: string;
  slug: string;
  postCount: number;
}

/**
 * Tag vocabularies are small (dozens, not thousands), so the manager
 * fetches them all in one page — react-admin convention, 0-indexed page.
 */
export const ALL_BLOG_TAGS = gql`
  query AllBlogTagsForManager {
    allBlogTags(page: 0, perPage: 1000, sortField: "name", sortOrder: "ASC") {
      id
      name
      slug
      postCount
    }
  }
`;

export const CREATE_BLOG_TAG = gql`
  mutation CreateBlogTag($name: String!) {
    createBlogTag(name: $name) {
      id
      name
      slug
      postCount
    }
  }
`;

export const UPDATE_BLOG_TAG = gql`
  mutation UpdateBlogTag($id: String!, $name: String!) {
    updateBlogTag(id: $id, name: $name) {
      id
      name
      slug
      postCount
    }
  }
`;

export const DELETE_BLOG_TAG = gql`
  mutation DeleteBlogTag($id: String!) {
    deleteBlogTag(id: $id) {
      id
    }
  }
`;
